module.exports = __webpack_public_path__ + "img/IMG_5891.46999ad7.jpg";